module.exports = __webpack_public_path__ + "static/media/sms-icon.35ddff7d.svg";